import { trackEvent } from './monitoring';
import { getDeployment } from './appEnvironment';

export const apiTrace = (apiRes) => {
  const data = {
    api: apiRes.request.responseURL,
    method: apiRes.config.method,
    status: apiRes.status,
    appEnvironment: getEnv(),
    traceId: apiRes.headers?.['x-b3-traceid']
  };
  trackEvent(extractApiWord(apiRes.request.responseURL) + 'WebRequests', data);
};

const extractApiWord = (url) => {
  const match = /api\/([^/]+)/.exec(url);
  if (match && match[1]) return match[1];
  else return null;
};

const getEnv = () => getDeployment().env;

export const getRegion = () => getDeployment().region;
